import { Card, Image } from '@fluentui/react-components';
import { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrashCan } from '@fortawesome/free-solid-svg-icons';
import { useCart } from '../../../../contexts/CartContext/CartContext.hooks';
import { IAccessoryItem } from '../../../../contexts/CartContext/CartContext.types';
import { Stack } from '../../../../components/core';
import QuantitySection from '../../../Products/QuantitySection/QuantitySection';
import RemoveItemPopup from '../../popups/RemoveItemPopup/RemoveItemPopup';
import { useAccessoryCardStyles } from './AccesoryCard.styles';
import MaxItemPopup from '../../../../components/popups/MaxItemPopup/MaxItemPopup';

export interface IAccessoryCardProps {
    accessory: IAccessoryItem;
    readonly?: boolean;
}

const AccessoryCard = (props: IAccessoryCardProps) => {
    const { accessory, readonly } = props;

    const { cart, updateAccessories } = useCart();

    const styles = useAccessoryCardStyles();

    const [, setQuantity] = useState<number>(accessory.quantity);
    const [maxItemPopup, setMaxItemPopup] = useState(false);

    const [removeItemPopup, setRemoveItemPopup] = useState<boolean>(false);
    const closeRemoveItemPopup = (shouldDelete: boolean) => {
        setRemoveItemPopup(false);
        if (shouldDelete) {
            const accessoryCart = cart.accessories.filter(
                (x) => x.product.baseInfo.name != accessory.product.baseInfo.name
            );
            updateAccessories(accessoryCart);
        }
    };

    const UpdateQuantity = function (updatedQuantity: number) {
        if (updatedQuantity >= 15) setMaxItemPopup(true);
        setQuantity(updatedQuantity);

        const accessoryCart = cart.accessories.map((x) => {
            if (x.product.baseInfo.name !== accessory.product.baseInfo.name) return x;
            x.quantity = updatedQuantity;
            x.cartValue = x.quantity * (x.productSku?.sku.price ?? 0);
            return x;
        });
        updateAccessories(accessoryCart);
    };

    return (
        <Card className={styles.root}>
            <div className={styles.accessoryWrapper}>
                <Stack horizontal className={styles.detailsWrapper}>
                    <div className={styles.imageContainer}>
                        <Image
                            key={accessory.image}
                            alt={accessory.image}
                            src={accessory.image}
                            className={styles.image}
                        />
                    </div>
                    <div>
                        <b className={styles.title}>{accessory.product.baseInfo.name}</b>
                        <QuantitySection
                            readonly={readonly}
                            maxQuantity={15}
                            cartView={true}
                            startingQuantity={accessory.quantity}
                            onChange={UpdateQuantity}
                        />
                    </div>
                </Stack>
                <Stack horizontal spaced className={styles.dueToday}>
                    <div>
                        <p className={styles.itemInfoLabel}>Due Today</p>
                        <b className={styles.info}>${accessory.cartValue.toFixed(2)}</b>
                    </div>
                </Stack>

                <div className={styles.mobileLineBreak}></div>

                {!readonly && (
                    <div className={styles.removeItemContainer}>
                        <div className={styles.removeLabel}>Remove from cart</div>
                        <FontAwesomeIcon
                            data-testid='accessory-delete-button'
                            className={styles.deleteIcon}
                            icon={faTrashCan}
                            onClick={() => setRemoveItemPopup(true)}
                        />
                    </div>
                )}
            </div>
            {!readonly && (
                <>
                    <RemoveItemPopup
                        showPopup={removeItemPopup}
                        onDialogClose={closeRemoveItemPopup}
                    />
                    <MaxItemPopup
                        showPopup={maxItemPopup}
                        setPopup={setMaxItemPopup}
                        popupHeader={
                            'To add more than 15 of this accessory, please chat with us or visit our store.'
                        }
                    />
                </>
            )}
        </Card>
    );
};

export default AccessoryCard;
